import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
  OptionalDocumentModalV2Styles,
  OptionalDocumentSubmit,
} from './OptionalDocumentModal.styles';
import axe from '../../../services/axios-client/axiosClient';
import {
  generalAlertError,
} from '../../utils/alerts';
import { sonnerSuccessAlert } from '../../utils/sonnerAlerts';
import { FormInputSelect } from '../../formInputsV2/FormInputSelect';

const schema = yup.object({
  optional_document_type_id: yup
    .string()
    .required('Il campo è obbligatorio.'),
});

function OptionalDocumentModal({
  quotationId, closeModal, collectQuoteData,
}) {
  const [optionalDocumentTypes, setOptionalDocumentTypes] = useState([]);

  useEffect(() => {
    const run = async () => {
      const response = await axe.get('/get-optional-document-types');

      if (response.status === 200) {
        setOptionalDocumentTypes(response.data.data);
      }
    };

    run();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
  } = useForm({
    mode: 'all',
    resolver: yupResolver(schema),
    shouldFocusError: true,
    defaultValues: {
      optional_document_type_id: null,
    },
  });

  const isValid = (name) => {
    if (errors[name]?.message !== undefined) {
      return false;
    }

    if (touchedFields[name] === undefined) {
      return false;
    }

    return true;
  };

  const sendOptionalDocumentRequest = async (data) => {
    const response = await axe.post(`/quotations/${quotationId}/optional-documents/add-type`, data);

    if (response.status === 400) {
      if (response.data.error === 'cannot_add_more_document_types') {
        generalAlertError('Non è possibile aggiungere più di 5 tipi di documento');
        closeModal();
        return;
      }
    }

    if (response.status !== 200) {
      generalAlertError('Non è possibile aggiungere il tipo di documento');
      closeModal();
      return;
    }

    sonnerSuccessAlert('Tipo di documento aggiunto');
    closeModal();
    collectQuoteData();
  };

  return (
    <OptionalDocumentModalV2Styles>
      <div className="modal-dialog" role="dialog" aria-modal="true" aria-labelledby="optional-document-boxLabel">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="optional-document-boxLabel">
              Documento facoltativo
            </h1>
            <button
              id="close-modal-button"
              type="button"
              className="btn-close"
              aria-label="Chiudi"
              onClick={() => closeModal()}
            />
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit(sendOptionalDocumentRequest)}>
              <FormInputSelect
                placeholder="Seleziona tipo di documento"
                label="Seleziona tipo di documento"
                name="optional_document_type_id"
                registration={register('optional_document_type_id')}
                error={errors.optional_document_type_id?.message}
                valid={isValid('optional_document_type_id')}
                options={optionalDocumentTypes}
              />

              <OptionalDocumentSubmit type="submit">
                Richiedi l'aggiunta di un documento facoltativo
              </OptionalDocumentSubmit>
            </form>
          </div>
        </div>
      </div>
    </OptionalDocumentModalV2Styles>
  );
}

export default OptionalDocumentModal;
